<template>
    <div>
        <PageTable hideExport hideTitle ref="dataTable" :auto-load="true" :data="dataTable"
                   @load-data="dataTableLoad" highlight-current-row stripe border>
          <el-table-column label="传输方向" align="center" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.sptype==='1'">{{ "发送" }}</span>
              <span v-else>{{ "接收" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="运行状态" align="center" width="80">
            <template slot-scope="{ row }">
              <el-tag v-if="row.csstatus === '-1'">初始化失败</el-tag>
              <el-tag v-else-if="row.csstatus === '0'">未初始化</el-tag>
              <el-tag v-else-if="row.csstatus === '1'">初始化成功</el-tag>
              <el-tag v-else-if="row.csstatus === '2'">已启动</el-tag>
              <el-tag v-else-if="row.csstatus === '-2'">已停用</el-tag>
              <el-tag v-else-if="row.csstatus === '-3'">已停止</el-tag>
              <el-tag v-else>初始化</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="企业身份编码" prop="entdxpid" align="center"></el-table-column>
          <el-table-column label="目标身份编码" prop="dxpid" align="center"></el-table-column>
          <el-table-column label="本地协议" prop="csptname" align="center"></el-table-column>
          <el-table-column label="本地资源" prop="csres" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="传输协议" prop="pdptname" align="center"></el-table-column>
          <el-table-column label="传输资源" prop="pdres" align="center" show-overflow-tooltip></el-table-column>
        </PageTable>
    </div>
</template>
<script>
import idApi from "@/api/senior/idApi.js";

export default {
    props: {
      res:""
    },
    data() {
        return {
            dataTable: [],
        };
    },
    methods: {
        dataTableLoad(params, resole) {
            idApi.queryMondataTable(this.res.identityUuid)
              .then(resole)
              .then(resp => {
              this.dataTable = resp.datarows;
            });
        }
    }
};
</script>
